import { PersonModalMessage } from "./PersonModalMessage";
import { StudentModalMessage } from "./StudentModalMessage";
import { SessionModalMessage } from "./SessionModalMessage";
import { SystemModalMessage } from "./SystemModalMessage";
import type { StudentDataType } from "ft-shared-graphql";
import { createElement, Fragment } from "react";
export const messageComponents = {
    ...PersonModalMessage,
    ...StudentModalMessage,
    ...SessionModalMessage,
    ...SystemModalMessage
}
export type ModalType = keyof typeof messageComponents;
export type ModalMessageContext = {
    students?: StudentDataType[];
    sessionLink?: string;
    modalAction?: () => void;
}
type ModalMessageProps = {
    type?: ModalType | null;
    context?: ModalMessageContext | null;
};

function ModalMessage({ type, context }: ModalMessageProps) {
    const entry = messageComponents[type ?? "UNKNOWN"];
    const content = typeof entry === "function" ? entry(context ?? {}) : entry;
    return createElement(Fragment, null, content);
    // return type
    //     ? messageComponents[type]
    //     : messageComponents['UNKNOWN'];
}

export { ModalMessage }